import { BehaviorSubject, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import ErrorType from './Constants/Error.type';
import mapToConsumerError from './Utils/ConsumerOutput/mapToConsumerError';

class ErrorsHandler {
    constructor() {
        this.reportError$ = new Subject();
        this.consumerError$ = new BehaviorSubject(null);

        this.consumerSubscription = this.subscribeToConsumerErrors();
    }

    handleError = error => {
        if (typeof error.type !== 'string' || !error.type) {
            this.handleError({
                type: ErrorType.UNKNOWN_ERROR,
                source: error,
            });
        }
        this.reportError$.next(error);
    }

    subscribeToConsumerErrors = () =>
        this.reportError$
            .pipe(
                map(mapToConsumerError)
            )
            .subscribe(this.consumerError$);
}

export default ErrorsHandler;
